import Vue from 'vue';
import VueRouter from 'vue-router';
import Invite from '../views/Invite.vue';
import NotFound from '../views/NotFound.vue';
import store from '../store';

Vue.use(VueRouter);

const routesChildren = [
  {
    path: 'invite/:hash',
    name: 'invite',
    component: Invite,
  },
  {
    path: 'logout',
    name: 'logout',
    component: () => import('../views/Logout.vue'),
  },
  {
    path: 'account',
    name: 'account',
    component: () => import('../views/Account.vue'),
  },
  {
    path: 'contact',
    name: 'contact',
    component: () => import('../views/Contact.vue'),
  },
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: 'deals',
    name: 'deals',
    component: () => import('../views/Deals.vue'),
  },
  /*
  {
    path: 'deals/view/:dealId',
    name: 'deals/view',
    component: () => import('../views/DealsView.vue'),
  },
  */
  {
    path: 'estimates',
    name: 'estimates',
    component: () => import('../views/Estimates.vue'),
  },
  {
    path: 'estimates/view/:estimateId',
    name: 'estimates/view',
    component: () => import('../views/EstimatesView.vue'),
  },
  {
    path: 'events',
    name: 'events',
    component: () => import('../views/Events.vue'),
  },
  {
    path: 'events/view/:eventId',
    name: 'events/view',
    component: () => import('../views/EventsView.vue'),
  },
  {
    path: 'files',
    name: 'files',
    component: () => import('../views/Files.vue'),
  },
  {
    path: 'invoices',
    name: 'invoices',
    component: () => import('../views/Invoices.vue'),
  },
  /*
  {
    path: 'invoices/view/:invoiceId',
    name: 'invoices/view',
    component: () => import('../views/InvoicesView.vue'),
  },
  */
  {
    path: 'request-service',
    name: 'request-service',
    component: () => import('../views/RequestService.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/customer_portal/' : process.env.BASE_URL,
  // routes,
  routes: [
    {
      path: '/app/',
      component: {
        render(h) { return h('router-view'); },
      },
      children: routesChildren,
    },
    /*
    // pro home
    {
      path: '/:slug([A-Za-z0-9-_]+)/',
      name: 'prohome',
      component: ProHome,
    },
    */
    {
      path: '404',
      name: 'notfound',
      component: NotFound,
    },
    // catch all for the 404 page
    {
      path: '*',
      redirect: { name: 'notfound' },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name === 'invite' || to.name === 'logout') {
    next();
  } else {
    if (store.getters.isAuth) {
      next();
      return;
    }

    next({ name: 'logout' });
  }
});

export default router;
